import { useFormState } from 'react-final-form';

import { Box } from '@occc-app/design-system';
import { EarningMechanismAwardSelector } from '@occc-app/offerHelpers/components/earning-mechanism-award-selector';
import { AwardType } from '@occc-app/offerHelpers/types';
import { useMakeOffersFilter } from '@occc-app/offerHelpers/hooks/use-make-offers-filter.hook';

import {
  ReferralProgramConfigurationValues,
  ReferralProgramConfigurationValuesPaths,
} from '../../referral-program-configuration.types';

export const ReceiverConfigurationForm = () => {
  const { values } = useFormState<ReferralProgramConfigurationValues>();
  const makeOffersFilter = useMakeOffersFilter();

  return (
    <Box>
      <EarningMechanismAwardSelector
        buttonTypes={[AwardType.AwardNullable, AwardType.AwardPoints, AwardType.AwardVouchers]}
        title='Give Receivers'
        makeOffersFilter={makeOffersFilter}
        values={{
          awardType: values.receiver.award.type,
        }}
        awardTypeFieldName={'receiver.award.type' satisfies ReferralProgramConfigurationValuesPaths}
        awardPointsFieldName={
          'receiver.award.points' satisfies ReferralProgramConfigurationValuesPaths
        }
        awardVoucherFieldName={
          'receiver.award.voucheredOffer' satisfies ReferralProgramConfigurationValuesPaths
        }
        awardVoucherCountFieldName={
          'receiver.award.voucherCount' satisfies ReferralProgramConfigurationValuesPaths
        }
        awardVoucherExpirationFieldName={
          'receiver.award.voucheredOfferExpirationDays' satisfies ReferralProgramConfigurationValuesPaths
        }
        awardVoucherExpirationEnabled
      />
    </Box>
  );
};
